// Move to wisr-common-js
export const isNotEmpty = <T>(object?: T | null): object is T => {
  return object != null && Object.keys(object).length !== 0;
};
